export type RangeCompositeValue = {
  min?: string;
  max?: string;
};

export function parseRangeCompositeValue(
  value: string,
): RangeCompositeValue | null {
  if (!value) return null;
  try {
    const parsed: unknown = JSON.parse(value);
    if (!parsed || typeof parsed !== 'object') return null;
    const obj = parsed as Record<string, unknown>;
    const result: RangeCompositeValue = {};
    if (typeof obj.min === 'string') result.min = obj.min;
    if (typeof obj.max === 'string') result.max = obj.max;
    return result;
  } catch {
    return null;
  }
}

export function stringifyRangeCompositeValue(obj: RangeCompositeValue): string {
  return JSON.stringify(obj);
}
